import 'assets/css/modal.css';
import 'styles/custom.css';
import * as React from 'react';
import { updateDefaultSetting, GetCurrentDefaultSetting } from "../components/Requests/Requests"
import { 
  StandardScreen,
  StandardTextField,
  StandardButton, 
  StatusMessage,
  PageLayout
} from '../components/Layout';

class ListUtilities extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            defaultItemLimit: "",
            defaultItemLimitMessage: "",
            defaultItemLimitError: "",
            loading: false
        }
    }

    constructAndSendRequest() {
        let requestBody = {
            settingValue: this.state.defaultItemLimit === "" ? null : this.state.defaultItemLimit,
            settingName: "MaxListItemsPageSize",
        };

        this.updateDefaultItemLimit(requestBody);
    }
    
    async updateDefaultItemLimit(requestBody) {
        this.setState({ loading: true })
        let response = await updateDefaultSetting(this.props.accessToken, requestBody);
        if (response.status === 200) {
            let data = await response.json();
            this.setState({ defaultItemLimitError: "", defaultItemLimitMessage: data.message, loading: false });
        } else if(response.status === 401){
            this.setState({ loading: false, defaultItemLimitError: "You are not permitted to update this value. You must request admin permissions", defaultItemLimitMessage: "" });
        } 
        else {
            this.setState({ loading: false, defaultItemLimitError: "Something went wrong", defaultItemLimitMessage: "" });
        };
    }

    async GetCurrentDefaultSetting(){
        this.setState ({ loading: true});
        let response = await GetCurrentDefaultSetting(this.props.accessToken, "MaxListItemsPageSize");
        let data = await response.json();
        if (response.status === 200){
            this.setState({ loading: false, defaultItemLimitMessage: "Current "+ data.settingName + ": " + data.value})
        } else{
            this.setState({ loading: false, defaultItemLimitError: "Something went wrong", defaultItemLimitMessage: "" });
        }
    }

    onDefaultItemLimitChange = (event, newValue) => {
        this.setState({ 
            defaultItemLimit: newValue,
            defaultItemLimitError: "",
            defaultItemLimitMessage: ""
        });
    };

    render() {
        const {
            defaultItemLimit,
            defaultItemLimitMessage,
            defaultItemLimitError,
            loading
        } = this.state;
        
        return (
            <PageLayout>
                <StandardScreen
                    title="Global Default Max List Items Page Size"
                    description="Change the default max list items page size for calls to get SharePoint list items, for all SPHostURLs and in all environments"
                    loading={loading}
                >
                    <StandardTextField
                        label="New Limit"
                        type='number'
                        placeholder='New Default Item Limit'
                        value={defaultItemLimit}
                        onChange={this.onDefaultItemLimitChange}
                    />
                    <div style={{ display: 'flex', gap: '20px' }}>
                        <StandardButton
                            text='Find Value'
                            size="wide"
                            onClick={() => this.GetCurrentDefaultSetting()}
                            style={{ marginRight: '10px' }}
                        />

                        <StandardButton
                            text='Update Value'
                            size="wide"
                            disabled={!defaultItemLimit || !(this.state.defaultItemLimitMessage.includes("Current"))}
                            onClick={() => this.constructAndSendRequest()}
                        />
                    </div>

                    {defaultItemLimitError && (
                        <StatusMessage type="error">{defaultItemLimitError}</StatusMessage>
                    )}

                    {defaultItemLimitMessage && (
                        <StatusMessage type="success">{defaultItemLimitMessage}</StatusMessage>
                    )}
                </StandardScreen>
            </PageLayout>
        );
    }
}

export default ListUtilities;
